var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.159,
    height: 13.127,
    viewBox: "0 0 15.159 13.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28,19.093a1.853,1.853,0,0,0-.924.272l-2.97,1.714a1.425,1.425,0,0,0,0,2.63l2.97,1.714a1.846,1.846,0,0,0,.924.272,1.4,1.4,0,0,0,1.354-1.587V22.735a5.342,5.342,0,0,0,3.026-4.51c0-3.119-3.4-5.656-7.58-5.656a9.481,9.481,0,0,0-4.024.871l.465.936a8.536,8.536,0,0,1,3.559-.75c3.6,0,6.522,2.063,6.522,4.6a4.073,4.073,0,0,1-1.968,3.283v-.828A1.4,1.4,0,0,0,21.28,19.093Zm.3,5.016c0,.2-.038.53-.3.53a.807.807,0,0,1-.4-.13l-2.97-1.714c-.215-.124-.348-.277-.348-.4s.133-.275.348-.4l2.97-1.714a.849.849,0,0,1,.4-.13c.258,0,.3.331.3.53Zm-6.607-1.5a.539.539,0,0,0-.433-.528,4.529,4.529,0,0,1-2.979-3.853,3.99,3.99,0,0,1,1.772-3.142l-.623-.843A5.04,5.04,0,0,0,10.5,18.225c0,1.976,1.394,3.818,3.645,4.837a.53.53,0,0,0,.112.052l.007,0h0a.527.527,0,0,0,.166.029A.539.539,0,0,0,14.97,22.606Z",
    transform: "translate(-10.501 -12.568)",
    fill: "#3a3630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsRetry);
export default __webpack_public_path__ + "static/media/ctaIcons_Retry.948968b8fc6dec4e94a561746866772e.svg";
export { ForwardRef as ReactComponent };